export const toAVCID = id => {
  if (id?.includes('AVC')) {
    return id
  }

  return `AVC${id}`
}

export const fromAVCID = id => {
  if (id?.includes('AVC')) {
    return id?.replace('AVC', '')
  }

  return id
}
